import React from 'react';
import styled from 'styled-components';

import { useDeepCompareMemo } from '@clatter/platform';
import {
  NgCard,
  NgCardContent,
  NgCardTitle,
  WorkbookSampleDownload,
  NgWorkbookUploadCard,
  CardRailMenu,
} from '../../../components';
import { aclRolesMap } from '../../../constants';
import { hasAccessByRole } from '../../../helpers';

interface ProjectsLeftRailProps {
  grants?: UserGrants;
  isLoading?: boolean;
  workbookTargetKey?: string;
  projectData: any;
  projectSideNavItems: ProjectSideNavItem[];
  enableWorkbookUpload?: boolean;
  onWorkbookUploadComplete?: (data: IngestJob) => void;
}

const StyledContainer = styled.aside`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.medium};
`;

export const ProjectsLeftRail: React.FC<ProjectsLeftRailProps> = ({
  projectData: data,
  grants,
  isLoading,
  workbookTargetKey,
  projectSideNavItems,
  onWorkbookUploadComplete = () => {},
  enableWorkbookUpload,
}) => {
  const targetId = data?.ID;
  const sampleWorkbookUrl = useDeepCompareMemo(() => data?.ProjectTemplate?.SampleWorkbookUrl, [data]);

  const enableWorkbookActions = hasAccessByRole({ allowedRoles: [aclRolesMap.DATA_ADMIN], role: grants?.role });
  const isEtlEnabled = !!data?.ProjectTemplate?.HasEtl || data?.HasEtl;

  return (
    <StyledContainer>
      <CardRailMenu items={projectSideNavItems} grants={grants} isLoading={isLoading} />

      {enableWorkbookUpload ||
        (isEtlEnabled && enableWorkbookActions && (
          <>
            <NgWorkbookUploadCard
              data={data}
              targetKey={workbookTargetKey}
              targetId={targetId}
              uploadFolderId={data.UploadedDataFolderID}
              onComplete={onWorkbookUploadComplete}
            />

            {isEtlEnabled && sampleWorkbookUrl && (
              <NgCard>
                <NgCardContent>
                  <NgCardTitle title="Sample Workbook" />
                  <WorkbookSampleDownload downloadUrl={sampleWorkbookUrl} />
                </NgCardContent>
              </NgCard>
            )}
          </>
        ))}
    </StyledContainer>
  );
};
